import { createSlice } from "@reduxjs/toolkit";

const initialFollowupState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  lastError: null,
  followupForEdit: undefined,
  followupForExport: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const followupSlice = createSlice({
  name: "followup",
  initialState: initialFollowupState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    followupFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    followupAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    followupCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.followup.push(action.payload.followup);
    },
    followupDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.followup.filter(el => el.follow_up_id !== action.payload.id);
    },
    getFollowup: (state, action) => {
      state.actionsLoading = false;
      state.followupForEdit = action.payload.followupForEdit;
      state.error = null;
    },
    getExportFollowup: (state, action) => {
      state.actionsLoading = false;
      if (action.payload.followupForExport === undefined) {
        state.followupForExport = [];
      } else {
        state.followupForExport.push(action.payload.followupForExport);
      }
      state.error = null;
    },
    // updateProduct
    followupUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.followup = state.entities.followup.map(entity => {
        if (entity.follow_up_id === action.payload.followup.follow_up_id) {
          return action.payload.followup;
        }
        return entity;
      });
    },
  },
});
